export interface OrphanRelationshipDisplay {
  /** Label for a reference whose target is still missing from the repository. */
  notFoundText: string;
  /**
   * The extracted name to render on its own line above `notFoundText`, or null
   * when the hint never named its target. Same shape as other relationship rows:
   * title only (e.g. "Master Services Agreement").
   */
  secondLineName: string | null;
}

/**
 * The text an orphan relationship row shows, shared by the repository grid cell
 * and the document-summary drawer so both read identically for the same row.
 */
export function getOrphanRelationshipDisplay(args: {
  expectedDocumentName: string | null;
  /** Which side of the relationship is missing. */
  missingSide: 'child' | 'parent';
}): OrphanRelationshipDisplay {
  const { expectedDocumentName, missingSide } = args;

  return {
    notFoundText:
      missingSide === 'child' ? 'Child document not found' : 'Parent document not found',
    secondLineName: expectedDocumentName,
  };
}
